import Image from "next/image";
import { useRef } from "react";
import { useInView } from "framer-motion";
import style from "./GalleryBlock.module.scss";
import PinkFigure from "../../../public/remove_back/magic_bg/pink_gallery.svg";
import BlueFigure from "../../../public/remove_back/magic_bg/blue_gallery.svg";
import { galleryData } from "../../../constants/magic_bg_constants";

function GalleryBlock({ dictionary }) {
	const containerRef = useRef(null);
	const isInView = useInView(containerRef, { amount: 0.5, once: true });

	return (
		<section className={style.block} ref={containerRef}>
			<PinkFigure className={`${style.figure} ${style.pink}`} />
			<BlueFigure className={`${style.figure} ${style.blue}`} />
			<div className={style.text}>
				<h2 className={style.title}>{dictionary["Generate artworks in any style"] || "Generate artworks in any style"}</h2>
				<p className={style.description}>{dictionary["Look at the examples of images created by our online AI generator to get some inspiration"]}</p>
				<p className={style.description}>{dictionary["You can choose the style in our templates or describe the concept you need comprehensively and thoroughly in the prompt"]}</p>
			</div>
			<div className={style.container}>
				{galleryData.map((item) => (
					<div key={item.id} className={`${style.item} ${item.animation ? style.start : ""} ${isInView ? style.finish : ""}`}>
						<div className={style["image-box"]}>
							<Image src={item.src} width={312} height={312} alt={item.altName} style={{ objectFit: "contain", maxWidth: "100%", height: "auto" }} loading={"lazy"} />
						</div>
						<div className={style["item-text"]}>
							<p className={style.name} dangerouslySetInnerHTML={{ __html: dictionary[item.name] }}></p>
						</div>
					</div>
				))}
			</div>
		</section>
	);
}

export default GalleryBlock;
